exports = module.exports = require("../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "\n.file-addition,\n.file-addition-solid {\n  color: #1aaa55;\n}\n.file-modified,\n.file-modified-solid {\n  color: #fc9403;\n}\n.file-deletion,\n.file-deletion-solid {\n  color: #db3b21;\n}\n", ""]);

